import { LoadingButton } from '@mui/lab';
import {
  BottomNavigation,
  Box,
  ButtonProps,
  Menu,
  MenuList,
  MenuItem,
  styled,
  Tooltip,
  Typography,
} from '@mui/material';
// import MenuItem from '@mui/material/MenuItem';
import useDeliverableRights from 'hooks/rights/useDeliverableRights';
import useUserRoles from 'hooks/useUserRoles';
import React, { useCallback, useMemo, useState, useEffect, MouseEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  selectBLDeliverablesAction,
  selectAllBLDeliverablesAction,
  filterTotalFlagAction,
  selectBLDeliverablesListAction,
} from 'store/actions/changeBaselineActions';
import { openDialogAction } from 'store/actions/dialogsActions';
import { addLoadingAction, removeLoadingAction } from 'store/actions/loadingsActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';

import OrderWorkunit from 'types/entities/OrderWorkunit';
import { setSnackbarAction } from 'store/actions/snackbarActions';
import ChangeBaseLineAPIServices from 'api/ChangeBaseLineAPIServices';

type QuickActionStatusDisabled = {
  cancelDelete: boolean;
  restore: boolean;
  delete: boolean;
  newwu: boolean;
  cancel_newwu: boolean;
  eval?: boolean;
};

const DeliverableQuickActions: React.FC = () => {
  type MenuAction = 'delete' | 'restore' | 'cancel_delete' | 'newwu' | 'cancel_newwu';
  const [t] = useTranslation();
  const { dispatch } = useAppState();

  const loadings = useSelector((state) => state.loadings);
  const appState = useSelector((state) => state.app);
  const state = useSelector((state) => state.changeBaseline);

  // const clientConnection = useSelector((state) => state.deliverable.order?.client_connection);
  const [selectedDeliverables, selectSelectedDeliverables] = useState<OrderWorkunit[]>([]);

  const [quickActionStatusDisabled, setQuickActionStatusDisabled] = useState<QuickActionStatusDisabled>({
    cancelDelete: false,
    restore: false,
    delete: false,
    newwu: false,
    cancel_newwu: false,
    eval: false,
  });
  // const selectedDeliverablesForDuplicate = useSelector(duplicateSelectSelectedDeliverables);
  // const [cancelReason, setCancelReason] = useState<string | null>(null);
  const [event, setEvent] = useState<MouseEvent | null>(null);
  // const cancellationLabel = { inputProps: { 'aria-label': t('Cancel_selected_deliverables') } };
  // const cancellationSubmissionLabel = { inputProps: { 'aria-label': t('Cancel_submission_selected_deliverables') } };
  // const cancellationValidationLabel = { inputProps: { 'aria-label': t('Cancel_validation_selected_deliverables') } };
  // const userIsAdmin = appState.roles?.includes('admin');
  // const userIsConsultant = appState.roles?.toString().includes('consultant');
  // const userIsBm = appState.roles?.toString().includes('bm');
  // const userIsDC = appState.roles?.toString().includes('delivery_coordinator');
  // const userIsDM = appState.roles?.toString().includes('delivery_manager');
  const userIsCustomer = appState.user?.is_client; // TODO use customer roles ?
  // const canDeliverablesBeEvaluated = selectedDeliverables.every(
  //   (mission) =>
  //     mission.mission_advancement_id &&
  //     mission.mission_advancement_id >= MissionAdvancementPossibilities.RESERVE_CLIENT &&
  //     !mission.rating
  // );
  const userRights = useUserRoles();
  const { canEdit } = useDeliverableRights(
    state?.selectedBLDeliverablesList && !userRights.isClient ? [] : selectedDeliverables
  );
  // const isThereDuplicableDeliverables = selectedDeliverablesForDuplicate.some((deliv) => !deliv.workunit_id);
  // const isEveryDeliverableDuplicable = selectedDeliverablesForDuplicate.every((deliv) => !deliv.workunit_id);
  // const [triggerSubmit, setTriggerSubmit] = useState(false);
  // const [isRatingPopupOpen, setIsRatingPopupOpen] = useState<boolean>(false);

  const [anchorPosition, setAnchorPosition] = useState<{ top: number; left: number } | null>(null);
  // const [menuAction, setMenuAction] = useState<MenuAction | null>(null);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const selectModeAllDeliverables = useSelector((state) => state.deliverable.selectedAllDeliverables);
  const quickActionsButtonRef = useRef<HTMLButtonElement>(null);

  const orderType = useSelector((state) => state.deliverable.order?.order_type_id);

  const getSelectedDeliverableByListId = useCallback(async () => {
    // console.log('getDeliverableByListId called in useCallback');
    const deliverables = state?.selectedBLDeliverablesList;
    selectSelectedDeliverables(deliverables);
  }, [state?.changeBaselineData, state.selectedBLDeliverablesList, state.selectedBLDeliverablesModel]);

  useEffect(() => {
    // console.log('getSelectedDeliverableByListId useEffect called');
    getSelectedDeliverableByListId();
  }, [
    getSelectedDeliverableByListId,
    state.selectedBLDeliverablesList,
    state.selectedBLDeliverablesModel,
    isMenuVisible,
  ]);

  useEffect(() => {
    // const selectedIds = state.selectedBLDeliverablesModel; // e.g., [18, 22]
    // const selectedRows = state.totalworkunitData.filter((item) => selectedIds.includes(item.id));

    // const labelsLastValues = selectedRows.map((item) => {
    //   const labels = item.label?.split('|').filter(Boolean);
    //   return labels?.at(-1) || '';
    // });
    // console.log(labelsLastValues);
    // console.log('useEffect setQuickActionStatusDisabled');
    setQuickActionStatusDisabled({
      cancelDelete: isCancelDeleteDeliverableDisable(),
      restore: isRestoreDeliverableDisable(),
      newwu: isNewWuDeliverableDisable(),
      delete: isDeleteDeliverableDisable(),
      cancel_newwu: isCancelNewWuDeliverableDisable(),
      // eval: canUserEvaluateDeliverables(),
    });
    // if (!state.selectedBLDeliverablesModel) {
    //   setQuickActionsAffectation({
    //     ...quickActionsAffectation,
    //     cancellation: countCancellableMissions(),
    //     submission: countSubmittableDeliverable(),
    //     validation: countValidableDeliverables(),
    //     cancelsubmission: countCancellableSubmittedDeliverables(),
    //     cancelvalidation: countCancellableValidatedDeliverables(),
    //     delete: countDeletableDeliverable(),
    //   });
    // }
    // console.log('quickActionStatusDisabled inner:', quickActionStatusDisabled);
  }, [selectedDeliverables, state.selectedBLAllDeliverables]);

  const handleActions = async (item: any) => {
    if (item.loadingName) dispatch(addLoadingAction(`action${item.loadingName}`));
    await item.action();
    if (item.loadingName) dispatch(removeLoadingAction(`action${item.loadingName}`));
  };

  const openEditDeliverableDrawer = useCallback(async () => {
    dispatch(
      openDialogAction({
        name: 'changeBaselineeditworkunitDialog',
        data: { data: state.selectedBLDeliverablesModel, type: 'multiple' },
      })
    );
    // dispatch(
    //   openDrawerAction({
    //     name: 'deliverableEdit',
    //     data: state.selectedBLDeliverablesModel,
    //   })
    // );
  }, [dispatch, state.selectedBLDeliverablesModel]);

  const isNewWuDeliverableDisable = () => {
    if (state.selectedBLAllDeliverables) {
      return false;
    }
    const allMatch = state.selectedBLDeliverablesList.every(
      (row) =>
        row?.mission_advancement_id === null &&
        ![1, 2, 3, 4, 5, 6, 7].includes(row?.mission_advancement_id) &&
        row?.label?.includes('added') &&
        !row?.label?.includes('New WU') &&
        !row?.label?.includes('Deleted')
    );
    return allMatch;
  };

  const isCancelDeleteDeliverableDisable = () => {
    // if (state.selectedBLAllDeliverables) {
    //   return false;
    // }
    const labelsLastValues = state.selectedBLDeliverablesList.map((item) => {
      const labels = item.label?.split('|').filter(Boolean);
      return labels?.at(-1) || '';
    });
    return !state.selectedBLDeliverablesList.every((m) => !labelsLastValues.every((val) => val === 'Deleted'));
  };

  const isRestoreDeliverableDisable = () => {
    // if (state.selectedBLAllDeliverables) {
    //   return false;
    // }
    const labelsLastValues = state.selectedBLDeliverablesList.map((item) => {
      const labels = item.label?.split('|').filter(Boolean);
      return labels?.at(-1) || '';
    });
    return !state.selectedBLDeliverablesList.every((m) => !labelsLastValues.every((val) => val === 'cancelled'));
  };

  const isDeleteDeliverableDisable = () => {
    // if (state.selectedBLAllDeliverables) {
    //   return false;
    // }
    const allMatch = state.selectedBLDeliverablesList.every(
      (row) =>
        row?.mission_advancement_id === null &&
        ![1, 2, 3, 4, 5, 6, 7].includes(row?.mission_advancement_id) &&
        !row?.label?.includes('Deleted')
    );

    return allMatch;
  };

  const isCancelNewWuDeliverableDisable = () => {
    const allMatch = state.selectedBLDeliverablesList.every(
      (row) =>
        row?.mission_advancement_id === null &&
        ![1, 2, 3, 4, 5, 6, 7].includes(row?.mission_advancement_id) &&
        row?.label?.includes('added') &&
        row?.label?.includes('New WU') &&
        !row?.label?.includes('Deleted')
    );
    return allMatch;
  };

  const actions = useMemo(
    () => [
      {
        action: openEditDeliverableDrawer,
        permission: canEdit,
        // permission: true && !state.selectedBLAllDeliverables && selectedDeliverables.length > 0,
        label: t('Mass edit'),
      },
    ],
    [t, openEditDeliverableDrawer, canEdit, selectedDeliverables, state.selectedBLAllDeliverables]
  );

  const NavigationBottom = styled(LoadingButton)<ButtonProps>(({ theme }) => ({
    color: theme.palette.primary.main,
    backgroundColor: '#FFFFFF',
    borderColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  }));

  const actionsAvailables = useMemo(() => actions.filter((item) => item.permission !== false), [actions]);
  const selectedItems = () => `${state.selectedBLDeliverablesModel?.length} ${t('items_selected')}`;

  // added condition for client
  const handleOpen = useCallback(
    (event) => {
      event.preventDefault();
      if (quickActionsButtonRef.current) {
        const rect = quickActionsButtonRef.current.getBoundingClientRect();
        const userIsClient = appState?.user?.is_client ?? false;
        if (!userIsClient) {
          setAnchorPosition({
            top: rect.bottom - 250,
            left: rect.left,
          });
        } else {
          setAnchorPosition({
            top: rect.bottom - 180,
            left: rect.left,
          });
        }

        setIsMenuVisible(true);
      }
    },
    [appState, quickActionsButtonRef]
  );

  const handleClose = useCallback(() => {
    setAnchorPosition(null);
    setIsMenuVisible(false);
  }, []);

  const handleMenuItemClick = (action: MenuAction, event: MouseEvent) => {
    // Handle menu item action here
    switch (action) {
      case 'delete':
        handleDelete(event);
        break;
      case 'restore':
        handleRestore(event);
        break;
      case 'newwu':
        handleNewWorkuit(event);
        break;
      case 'cancel_delete':
        handleCancelDelete(event);
        break;
      case 'cancel_newwu':
        handleCancelnewWU();
        break;
      default:
        console.log('handleMenuItemClick');
    }

    handleClose();
  };

  const submit = async (title: string) => {
    let updatedList = [];
    if (title === 'Restore') {
      updatedList = state.selectedBLDeliverablesList.map((item) => {
        if (!item.label) return item;
        const labels = item.label.split('|').filter(Boolean);
        if (labels.at(-1) === 'cancelled') {
          labels.pop();
          return { ...item, label: labels.join('|') };
        }
        return item;
      });
    } else if (title === 'Cancel Delete') {
      updatedList = state.selectedBLDeliverablesList.map((item) => {
        if (!item.label) return item;
        const labels = item.label.split('|').filter(Boolean);
        if (labels.at(-1) === 'Deleted') {
          labels.pop();
          return { ...item, label: labels.join('|') };
        }
        return item;
      });
    } else if (title === 'New Workunit') {
      updatedList = state.selectedBLDeliverablesList.map((item) => {
        if (!item.label) return item;
        return { ...item, label: `${item.label}|New WU` };
      });
    } else if (title === 'Cancel New WU') {
      updatedList = state.selectedBLDeliverablesList.map((item) => {
        if (!item.label) return item;
        const labels = item.label.split('|').filter(Boolean);
        if (labels.at(-1) === 'New WU') {
          labels.pop();
          return { ...item, label: labels.join('|') };
        }
        return item;
      });
    } else {
      updatedList = state.selectedBLDeliverablesList.map((item) => {
        if (!item.label) return item;
        return { ...item, label: `${item.label}|Deleted`, is_archived: true };
      });
    }
    const idAndLabelList = updatedList.map((item) => ({
      id: item.id,
      label: item.label ?? '',
      is_archived: title === 'Delete' ? item.is_archived : false,
    }));

    const baseLinePara = {
      page_typeid: 3,
      workunit_type: 'multiple',
      order_baseline_id: Number(state?.baseLineOrder?.id),
      source_order_id: Number(state?.sourceOrder?.id),
      baseline_version:
        state?.sourceOrder?.baseline_version === 0 || state?.sourceOrder?.baseline_version == null
          ? 1
          : state?.sourceOrder?.baseline_version + 1,
    };
    const toSend: {
      ressources: number[];
      data: {
        order_baseline_id: number;
        source_order_id: number;
        status: number;
        label_data: { id: number; label: string }[];
      };
    } = {
      ressources: state.selectedBLDeliverablesModel.filter((id: any) => typeof id === 'number'),
      data: {
        order_baseline_id: Number(state?.baseLineOrder?.id),
        source_order_id: Number(state?.sourceOrder?.id),
        status: 1,
        label_data: idAndLabelList,
      },
    };
    try {
      const res = await ChangeBaseLineAPIServices.bulkUpdate(baseLinePara, toSend.ressources, toSend.data, false);
      dispatch(selectBLDeliverablesAction([]));
      dispatch(selectBLDeliverablesListAction([]));
      dispatch(selectAllBLDeliverablesAction(false));
      dispatch(filterTotalFlagAction(true));
      if (res) dispatch(setSnackbarAction({ message: 'Saved', open: true, severity: 'success', duration: 500 }));
      updatedList = [];
    } catch (error) {
      const result = (error as Error).message;
      if (result) {
        dispatch(
          setSnackbarAction({ message: `Unable to save affectations: ${result}`, open: true, severity: 'error' })
        );
      } else {
        dispatch(
          setSnackbarAction({ message: `Unable to save affectations: ${error}`, open: true, severity: 'error' })
        );
      }
    }
  };

  const handleQuickAction = (message: string, title: string) => {
    const confirmOk = async (cancelReason?: string) => {
      submit(title);
    };

    dispatch(
      openDialogAction({
        name: 'ConfirmationDialogQuickAction',
        data: {
          message,
          title,
          confirm: confirmOk,
        },
      })
    );
  };

  const handleDelete = (event: MouseEvent) => {
    setEvent(event);
    handleQuickAction('Are you sure to delete the selected workunits?', 'Delete');
  };

  const handleRestore = (event: MouseEvent) => {
    setEvent(event);
    handleQuickAction('Are you sure to restore selected cancelled Items?', 'Restore');
  };

  const handleCancelDelete = (event: MouseEvent) => {
    setEvent(event);
    handleQuickAction('Are you sure to restore selected deleted Items?', 'Cancel Delete');
  };

  const handleNewWorkuit = (event: MouseEvent) => {
    submit('New Workunit');
    // setEvent(event);
    // handleQuickAction('Moved the tag to the NewWU tag?', 'New Workunit');
  };

  const handleCancelnewWU = () => {
    submit('Cancel New WU');
  };

  const isLoadingApi = !!loadings.api;

  return (
    <>
      {/* {canUseQuickActions &&
        actionsAvailables?.length > 0 &&
        (!!state.selectedBLDeliverablesModel?.length || state.selectedBLAllDeliverables) && ( */}
      <BottomNavigation
        sx={{
          borderRadius: '12px',
          backgroundColor: 'primary.main',
          // position: 'fixed',
          position: 'relative',
          flexDirection: { xs: 'column', md: 'row' },
          bottom: '15px',
          right: '25px',
          left: { xs: '10px', md: '10px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          color: '#FFFFFF',
          height: 'auto',
        }}
      >
        <Typography sx={{ fontWeight: 500, mb: { xs: 1, md: 0 } }}>{selectedItems()}</Typography>
        <Tooltip title="Affect every page">
          <NavigationBottom
            onClick={() => {
              dispatch(selectAllBLDeliverablesAction(false));
              dispatch(selectBLDeliverablesAction([]));
            }}
            sx={{ ml: 1, mb: { xs: 1, lg: 0 } }}
            size="small"
          >
            {t('Unselect all')}
          </NavigationBottom>
        </Tooltip>
        <Box sx={{ ml: 'auto', display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' }, flexWrap: 'wrap' }}>
          {actionsAvailables.map((item) => (
            <NavigationBottom
              key={item.label}
              onClick={() => handleActions(item)}
              sx={{ ml: 1, mb: { xs: 1, lg: 0 } }}
              size="small"
              loading={!!loadings[`action${item?.loadingName}`]}
              disabled={state.selectedBLDeliverablesModel?.length <= 1}
            >
              {item.label}
            </NavigationBottom>
          ))}
          {state.selectedBLDeliverablesModel && (
            <NavigationBottom
              ref={quickActionsButtonRef}
              aria-label="settings"
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleOpen}
              sx={{ ml: 1, mb: { xs: 1, lg: 0 } }}
              size="small"
            >
              Quick actions
            </NavigationBottom>
          )}
          <Menu
            anchorReference="anchorPosition"
            anchorPosition={
              anchorPosition !== null ? { top: anchorPosition.top, left: anchorPosition.left } : undefined
            }
            open={Boolean(anchorPosition)}
            onClose={handleClose}
          >
            <MenuList>
              {!userIsCustomer && (
                <Tooltip title="Removes a workunit (WU) from the new baseline." arrow>
                  <MenuItem
                    onClick={(event) => handleMenuItemClick('delete', event)}
                    disabled={isLoadingApi || !quickActionStatusDisabled.delete}
                  >
                    {t<string>('delete')}
                  </MenuItem>
                </Tooltip>
              )}
              {!userIsCustomer && (
                <Tooltip title="Reintegrates a previously cancelled workunit into the new baseline." arrow>
                  <MenuItem
                    onClick={(event) => handleMenuItemClick('restore', event)}
                    disabled={isLoadingApi || !quickActionStatusDisabled.restore}
                  >
                    {t<string>('restore')}
                  </MenuItem>
                </Tooltip>
              )}
              {!userIsCustomer && (
                <Tooltip
                  title="Cancels a deletion request and restores the workunit to the status it had before deletion."
                  arrow
                >
                  <MenuItem
                    onClick={(event) => handleMenuItemClick('cancel_delete', event)}
                    disabled={isLoadingApi || !quickActionStatusDisabled.cancelDelete}
                  >
                    {t<string>('cancel_delete')}
                  </MenuItem>
                </Tooltip>
              )}

              {!userIsCustomer && (
                <Tooltip title="Incorporate an Added WU to the baseline." arrow>
                  <MenuItem
                    onClick={(event) => handleMenuItemClick('newwu', event)}
                    disabled={isLoadingApi || !quickActionStatusDisabled.newwu}
                  >
                    {t<string>('newwu')}
                  </MenuItem>
                </Tooltip>
              )}

              {!userIsCustomer && (
                <Tooltip title="Cancel the incorporation of an Added WU to the baseline." arrow>
                  <MenuItem
                    onClick={(event) => handleMenuItemClick('cancel_newwu', event)}
                    disabled={isLoadingApi || !quickActionStatusDisabled.cancel_newwu}
                  >
                    {t<string>('cancel_newwu')}
                  </MenuItem>
                </Tooltip>
              )}
            </MenuList>
          </Menu>
        </Box>
      </BottomNavigation>
    </>
  );
};

export default DeliverableQuickActions;
